<ng-container *ngIf="!!pickupLocationMenu">
    <ion-segment [(ngModel)]="orderType" mode="ios" (ionChange)="select(orderType)">
        <ion-segment-button *ngIf="pickupLocationMenu.allowInHouse && !hideInHouse" value="IN_HOUSE"
                            class="order-type-selection">
            <ion-label>In House</ion-label>
        </ion-segment-button>
        <ion-segment-button *ngIf="pickupLocationMenu.allowTogo && !hideTogo" value="TOGO"
                            class="order-type-selection">
            <ion-label>To Go</ion-label>
        </ion-segment-button>
    </ion-segment>
</ng-container>
